import 'slick-carousel'
import jQuery from 'jquery'

class Slick {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: false,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null,
            nextArrow: null,
            prevArrow: null
        }, JSON.parse(this._elem.dataset.slick) || '{}')

        this._initialized = false

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }

        if (!this.options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    filterSlides (filter) {
        if (this._initialized) {
            jQuery(this._elem).slick('slickUnfilter')
            jQuery(this._elem).slick('slickFilter', filter)
        }
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        jQuery(this._elem).on('init', (e, slick) => {
            this._initialized = true
            this._elem.classList.add('show-slider')
            this._elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        jQuery(this._elem).not('.slick-initialized').slick(this.options)

        if (this.options.nextArrow) {
            jQuery(this.options.nextArrow).click(() => {
                jQuery(this._elem).slick('slickNext')
            })
        }

        if (this.options.prevArrow) {
            jQuery(this.options.prevArrow).click(() => {
                jQuery(this._elem).slick('slickPrev')
            })
        }

        jQuery(this._elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.pause()
            }
        })

        jQuery(this._elem).on('afterChange', (e, slick, curSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        this._reload()
        this._updaters()
    }

    _reload () {
        let reloaded = false
        if (this.options.reloadListener) {
            document.body.addEventListener('reloadSlick', e => {
                if (!reloaded) {
                    jQuery(this._elem).slick('resize')
                    reloaded = true
                }
            })
        }
    }

    _updaters () {
        const updaters = document.querySelectorAll('[data-slick-update]')
        updaters.forEach(updater => {
            const data = JSON.parse(updater.getAttribute('data-slick-update') || '{}')
            const elem = document.querySelector(data.elem)

            if (elem === this._elem) {
                updater.addEventListener('click', e => {
                    jQuery(this._elem).slick(data.method, (data.slide - 1))
                })
            }
        })
    }
}

export default Slick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slick.js